import { useEffect, useRef } from "react";
import { useCotiPluginContext } from "@/context/PrivacyBridgeContext";

/**
 * Dev aid: logs whenever the plugin's private unlock state flips. The plugin no
 * longer exposes the session AES key, so unlock state is the only observable
 * proxy for "a key is held in memory". Never logs key material.
 */
const AesSessionMemoryDebug = () => {
  const { walletAddress, isPrivateUnlocked } = useCotiPluginContext();
  const prevUnlockedRef = useRef<boolean>(Boolean(isPrivateUnlocked));

  useEffect(() => {
    const wasUnlocked = prevUnlockedRef.current;
    const isUnlocked = Boolean(isPrivateUnlocked);

    if (wasUnlocked && !isUnlocked) {
      console.log("[AES] Session key cleared from memory", {
        walletAddress: walletAddress || null,
      });
    } else if (!wasUnlocked && isUnlocked) {
      console.log("[AES] Session key loaded into memory", {
        walletAddress: walletAddress || null,
      });
    }

    prevUnlockedRef.current = isUnlocked;
  }, [isPrivateUnlocked, walletAddress]);

  return null;
};

export default AesSessionMemoryDebug;
